/** Whether a machine is out of service (ARCHITECTURE 8.10.3, I4). The DATABASE decides (fleet.blocking_restrictions); this twin only lets a
 *  device show the same answer while offline, which is why it lives next to the contracts and is proven equal to the SQL function on
 *  random scenarios by ops/contracts/check.mjs. A machine is blocked by every restriction that has not been released on ITSELF and on
 *  everything mounted on it right now, recursively (a restricted cutting unit takes its host out of service). Cycle-safe. */
export interface RestrictionLite { id: string; asset_id: string }
export interface MountLite { component_asset_id: string; host_asset_id: string }
export interface AvailabilityInput {
  restrictions: readonly RestrictionLite[]
  /** ids of restrictions that have a release row */
  released: ReadonlySet<string>
  /** only the mounts that are open now */
  openMounts: readonly MountLite[]
}

/** The assets that count for `assetId`: itself and, recursively, every component mounted on it. */
export function closureOf(assetId: string, openMounts: readonly MountLite[]): Set<string> {
  const seen = new Set<string>([assetId])
  const queue = [assetId]
  while (queue.length) {
    const host = queue.pop()!
    for (const m of openMounts) {
      if (m.host_asset_id === host && !seen.has(m.component_asset_id)) { seen.add(m.component_asset_id); queue.push(m.component_asset_id) }
    }
  }
  return seen
}

/** Sorted, de-duplicated ids of the restrictions that block `assetId` now. */
export function blockingRestrictionIds(assetId: string, input: AvailabilityInput): string[] {
  const assets = closureOf(assetId, input.openMounts)
  return [...new Set(input.restrictions.filter((r) => assets.has(r.asset_id) && !input.released.has(r.id)).map((r) => r.id))].sort()
}
